import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [location, setLocation] = useState(null);

  // Valid access codes (you can change these)
  const validCodes = ['REVIZR2025', 'PITCH2025'];

  // EmailJS configuration
  const EMAILJS_SERVICE_ID = 'service_qzv4qnd';
  const EMAILJS_TEMPLATE_ID = 'template_s8k4tq6';
  const EMAILJS_PUBLIC_KEY = 'V_8q6-Impyewc4Ex4';

  // Get user location
  useEffect(() => {
    // Get approximate location using IP geolocation
    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data => {
        setLocation({
          city: data.city,
          region: data.region,
          country: data.country_name,
          ip: data.ip
        });
      })
      .catch(() => {
        setLocation({
          city: 'Unknown',
          region: 'Unknown',
          country: 'Unknown',
          ip: 'Unknown'
        });
      });
  }, []);

  const sendLoginNotification = async (usedCode) => {
    try {
      const templateParams = {
        access_code: usedCode,
        timestamp: new Date().toLocaleString(),
        location: location ? `${location.city}, ${location.region}, ${location.country}` : 'Unknown',
        ip_address: location ? location.ip : 'Unknown',
        user_agent: navigator.userAgent.substring(0, 100) + '...'
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
    } catch (error) {
      // Silently fail - don't block login if notification fails
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validCodes.includes(code.toUpperCase())) {
      // Send notification before logging in
      await sendLoginNotification(code.toUpperCase());
      onLogin(true);
    } else {
      setError('Invalid access code');
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background"></div>
      
      <div className={`login-card ${shake ? 'shake' : ''}`}>
        <div className="login-logo">
          <h1>revizr.ai</h1>
          <p>AI Copilot for Measurable K-12 Exam Readiness</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter access code"
              className="code-input"
              autoFocus
            />
            <button type="submit" className="login-button">
              <span>Access Deck</span>
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        </form>
        
        <div className="login-footer">
          <p>Request access at <a href="mailto:info@revizr.ai">info@revizr.ai</a></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;